module.exports = __webpack_public_path__ + "img/videographer-1-400x300.c0b43b48.jpg";